import { useCallback, useEffect, useRef, useState } from 'react'

/** Scene-local, bounded by requested pages. Retry never resends a battle command. */
export function useSceneImages(urls: string[]) {
  const images = useRef(new Map<string, HTMLImageElement>())
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)
  const key = [...new Set(urls.filter(Boolean))].sort().join('|')
  useEffect(() => {
    let live = true
    const wanted = new Set(key.split('|').filter(Boolean))
    for (const [url, image] of images.current) if (!wanted.has(url) || (image.complete && !image.naturalWidth)) {
      image.onload = null; image.onerror = null; image.src = ''; images.current.delete(url)
    }
    setFailed(false)
    for (const url of wanted) {
      const existing = images.current.get(url)
      const image = existing ?? new Image()
      image.onerror = () => { if (live) setFailed(true) }
      images.current.set(url, image)
      if (!existing) image.src = url
    }
    return () => { live = false }
  }, [key, attempt])
  useEffect(() => {
    const bank = images.current
    return () => { for (const image of bank.values()) { image.onload = null; image.onerror = null; image.src = '' }; bank.clear() }
  }, [])
  const retry = useCallback(() => setAttempt(n => n + 1), [])
  return { images, failed, retry }
}
